import onboardingFrame1 from './frame1.png';
import onboardingFrame2 from './frame2.png';
import onboardingFrame3 from './frame3.png';
import onboardingFrame4 from './frame4.png';

export const OnboardingImagesMcosmetic = [
  onboardingFrame1,
  onboardingFrame2,
  onboardingFrame3,
  onboardingFrame4,
];
